import { Button, Text } from '@kanda-libs/ks-design-library';
import NumberedList from 'components/shared/NumberedList';
import TrustpilotBar from 'components/shared/TrustpilotBar';

import { replaceTradingName } from 'pages/Enquiry/helpers';
import { COPY, LIST } from './constants';
import useEnquiryQuoteWelcome from './useEnquiryQuoteWelcome';

const EnquiryQuoteWelcome: React.FunctionComponent = function () {
  const { onClick, tradingName, isLoading } = useEnquiryQuoteWelcome();
  return (
    <div className="flex flex-col w-full mb-auto pt-3">
      <Text
        className="mb-6"
        text={
          <h1 className="text-20-24-em md:text-24-28-em text-left">
            {replaceTradingName(COPY.header, tradingName)}
          </h1>
        }
        isLoading={isLoading}
        skeletonProps={{
          height: 28,
        }}
      />
      <Text
        className="mb-6"
        text={
          <h2 className="text-14-22 md:text-16-24 text-left">
            {replaceTradingName(COPY.body, tradingName)}
          </h2>
        }
        isLoading={isLoading}
        skeletonProps={{
          count: 4,
        }}
      />
      <NumberedList
        list={LIST.map((item) => ({
          header: replaceTradingName(item.header, tradingName),
          content: replaceTradingName(item.content, tradingName),
        }))}
        headerTextClassName="text-14-22-em md:text-16-24-em text-neutral-700"
        contentTextClassName="text-14-22 text-neutral-700"
        isLoading={isLoading}
      />
      <Button.Text
        id="enquiry-apply-start"
        label="Start Your Journey"
        icon="arrow-right"
        variant="gradient"
        onClick={onClick}
        className="mt-8"
        disabled={isLoading}
      />
      <TrustpilotBar wrapperClassName="my-6" />
    </div>
  );
};

export default EnquiryQuoteWelcome;
